
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz, ImagenMasivo } from '../../controlador';
    import { DataTableHeader } from 'vuetify';
    import { Utiles } from '@/__env/pluggins/event-bus';

    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Imagenes() { return this.Controlador.Imagenes; }
        public get Estado() { return this.Controlador.Vista.Estado; }
        //public get Seleccionados() { return this.Controlador.Seleccionados; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        mounted()
        {

        }

        async Eliminar( d: ImagenMasivo )
        {

            if ( !await Utiles.Mensajes.SiNo( 'Eliminar imagen', '¿Está seguro?' ) )
                return;

            this.Imagenes.splice( this.Imagenes.findIndex( x => x.Id == d.Id ), 1 );

        }

    }
